<template>
  <div
    class="py-4 block lg:fixed w-auto lg:w-5/6 mt-0 lg:mt-16 z-10"
    :class="{ 'theme-dark': nightMode, subnavbar: !nightMode }"
  >
    <div
      v-if="clusterSelected && clusterSelected.length > 0"
      class="
        block
        ml-4
        text-sm
        lg:flex lg:flex-cols-4
        lg:ml-0
        lg:text-lg
        justify-around
      "
      style="font-size:initial;"
      :class="{ 'border-mobile': !$isMobile() }"
    >
      <div>
        <span class="font-semibold">{{ $t("location") }}: </span>
        {{ clusterSelected[0].location }}
      </div>
      <div>
        <label class="mr-2 font-semibold" for="ports">{{ $t("name") }}:</label>
        <select
          name="ports"
          id="ports"
          form="portsform"
          class="subnavbar-border pr-4"
          @change="onChangeCluster($event)"
          :class="{ 'subnavbar-select-dark': nightMode, subnavbar: !nightMode }"
        >
          <option
            v-for="(cluster, index) in clusters"
            :key="index"
            :value="index"
          >
            {{ cluster.name }}
          </option>
        </select>
      </div>

      <div>
        <label class="mr-2 font-semibold" for="solarhubs">Solar HUB:</label>
        <select
          name="solarhubs"
          id="solarhubs"
          class="subnavbar-border"
          @change="onChange($event)"
          v-model="selectedHub"
          :class="{ 'subnavbar-select-dark': nightMode, subnavbar: !nightMode }"
        >
          <option
            v-for="(solarH, index) in clusterSelected[0].solarHubs"
            :key="index"
            :value="index"
          >
            {{ solarH.name }}
          </option>
        </select>
      </div>

      <div class="flex">
        <span class="font-semibold mr-2">{{ $t("last_updated") }}:</span>
        <div>
          {{ formatCurrentDate() }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Componente Subnavbar
 * --------------------------------------------
 *
 * Componente estático debajo del navbar que muestra el nombre del lugar, dos desplegables, uno con los clusters y otro 
 * con los solarhubs del cluster y la fecha de la útlima modificación
 *
 */
import { mapActions, mapState } from "vuex";
import { getClustersUser } from "@/utils/ClusterService.js";
export default {
  props: ["nightMode"],
  data() {
    return {
      selectedHub: 0,
      selectedCluster: 0,
      clusterSelected: {},
      clusters: [],
    };
  },
    /**
     * Método que al inciar el componente obtiene todos los clusters del usuario y guarda en cluster seleccionado el cluster marcado en el desplegable.
     * Actualiza en la store la data de los sensores.
     * 
     */
  async beforeCreate() {
    const data = await getClustersUser();
    this.clusters = data;
    this.clusterSelected = [data[this.selectedCluster]];
    this.changeCluster();
  },
  methods: {
    ...mapActions("clusters", ["loadCurrentCluster", "actionUpdateSensors"]),
    /**
     * Método que al cambiar de cluster actualiza el cluster seleccionado y obtiene la data de nuevo del cluster y actualiza en la store la data de los sensores.
     * 
     */
    async onChangeCluster(event) {
      this.selectedCluster = event.target.value;
        const data = await getClustersUser();
        if (data) {
          this.clusterSelected = [data[this.selectedCluster]];
          this.selectedHub = 0;
          this.changeCluster();
        }
     
    },
   /**
     * Método que al cambiar de solarhub actualiza el solarhub seleccionado y obtiene la data de nuevo del solarhub del cluster y actualiza en la store la data de los sensores.
     * 
     */
    onChange(event) {
      this.selectedHub = event.target.value;
      this.actionUpdateSensors({
        idCluster: this.clusterSelected[0].id,
        idSolarHub: this.clusterSelected[0].solarHubs[this.selectedHub].id,
      });
    },
    /**
     *  Método que al cambiar de cluster actualiza el cluster seleccionado y obtiene la data de nuevo del cluster y actualiza en la store la data con el cluster actual.
     * 
     */
    changeCluster() {
      this.actionUpdateSensors({
        idCluster: this.clusterSelected[0].id,
        idSolarHub: this.clusterSelected[0].solarHubs[this.selectedHub].id,
      });
      this.loadCurrentCluster(this.clusterSelected);
    },
    /**
     *  Método que da formato a la fecha de la útlma modificación.
     * 
     */
    formatCurrentDate() {
      if (Object.keys(this.sensorsList).length !== 0) {
        const data = this.sensorsList[0].time;
        let date = new Date(data);
        let lastDate = `${date.toLocaleDateString('es-ES')} ${date.toLocaleTimeString('es-ES')}`;
        return lastDate;
      } else {
        return "-----";
      }
    },
  },

  computed: {
    ...mapState("clusters", ["currentCluster"]),
    ...mapState("clusters", ["sensorsList"]),
  },
  watch: {
    selectedHub: {
      handler(val) {
        this.$root.$emit("selectedHub", this.selectedHub);
      },
    },
  },
};
</script>
<style scoped>
.border-mobile {
  justify-content: space-between;
  margin-left: 5%;
  margin-right: 5%;
}
.subnavbar {
  background-color: #121212;
  color: #dddddd;
}
.theme-dark {
  background: #ffffff;
  color: #121212;
}
.subnavbar-select-dark {
  background-color: #ffffff;
  border: 1px solid #68696d;
}
.subnavbar-border {
  border: 1px solid #68696d;
}
</style>